import {
  UseQueryOptions,
  UseQueryResult,
  useQuery,
} from '@tanstack/react-query';
import { QueryFetchFunction, QueryTransformer } from 'common/helpers/common';
import {
  ApiError,
  ApiResult,
  ExtendedApiResult,
} from 'common/repositories/common.model';

import {
  VisaDocumentLiteModel,
  VisaDocumentModel,
  VisaDocumentTransactionListModel,
  getVisaDocumentInput,
  getVisaDocumentTransactionList,
  getVisaDocumentsInput,
} from './model';

const BASE_URL = 'visa-documents';

export const visaDocumentKeys = {
  index: (input?: getVisaDocumentsInput) => ['get-visa-documents', input],
  view: (input?: getVisaDocumentInput) => ['get-visa-document', input],
  transactionList: (input: getVisaDocumentTransactionList) => [
    'get-visa-document-transaction-list',
    input,
  ],
};

export function useGetVisaDocuments(
  input?: getVisaDocumentsInput,
  options?: UseQueryOptions<
    ExtendedApiResult<VisaDocumentLiteModel[]>,
    ApiError
  >,
): UseQueryResult<ExtendedApiResult<VisaDocumentLiteModel[]>, ApiError> {
  return QueryTransformer(
    useQuery(
      options?.queryKey ?? visaDocumentKeys.index(input),
      () =>
        QueryFetchFunction({
          url: BASE_URL,
          params: input?.params,
        }),
      options,
    ),
    VisaDocumentLiteModel,
  );
}

export function useGetVisaDocument(
  input: getVisaDocumentInput,
  options?: UseQueryOptions<ApiResult<VisaDocumentModel>, ApiError>,
): UseQueryResult<ApiResult<VisaDocumentModel>, ApiError> {
  return QueryTransformer(
    useQuery(
      options?.queryKey ?? visaDocumentKeys.view(input),
      () =>
        QueryFetchFunction({
          url: `${BASE_URL}/${input.id}`,
        }),
      options,
    ),
    VisaDocumentModel,
  );
}

export function useGetVisaDocumentTransactionList(
  input: getVisaDocumentTransactionList,
  options?: UseQueryOptions<
    ApiResult<VisaDocumentTransactionListModel[]>,
    ApiError
  >,
): UseQueryResult<ApiResult<VisaDocumentTransactionListModel[]>, ApiError> {
  return QueryTransformer(
    useQuery(
      options?.queryKey ?? visaDocumentKeys.transactionList(input),
      () =>
        QueryFetchFunction({
          url: `${BASE_URL}/${input.id}/transaction-list`,
          params: input.params,
        }),
      options,
    ),
    VisaDocumentTransactionListModel,
  );
}

export function getVisaDocumentsKey(input?: getVisaDocumentsInput) {
  return visaDocumentKeys.index(input);
}

export function getVisaDocumentKey(input: getVisaDocumentInput) {
  return visaDocumentKeys.view(input);
}
